export class CoursePage {
	page_id: string;
	page_language: string;
	page_rubric: string;
	page_path: string;
	status: string;
	actual_status: string;
	flags: any;
	state_specific_content: string;
	skippable: boolean;
	deleted: boolean;
}
